import React, {useEffect,useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {useParams} from 'react-router';
import { useForm } from "react-hook-form";
import useTours from '../../../hooks/useTours';
import useAuth from '../../../hooks/useAuth';
import { bookingService } from '../../../services/bookingService';


const TourBooking = () => {
    const {tourId} = useParams();
    const [tours] = useTours();
    const [details, setDetails]= useState({});
    const { user } = useAuth();
    const navigate = useNavigate();
    const redirect_uri = '/myBooking';
    const {
      register,
      handleSubmit,
      reset,
      formState: { errors },
    } = useForm();

    useEffect(()=>{
        const matchTour = tours.find(singleTour=>singleTour._id===tourId);
        setDetails(matchTour);
    },[tourId,tours]);

    const onSubmit = (data) => {
        data.status= "Pending";
        bookingService.addBooking(data)
          .then((result) =>{
              alert("Booked Successfully!");
              reset();
              navigate(redirect_uri);
          })
          .catch(err => console.error(err));
    };

    return (
        <div className="py-24 bg-slate-50 min-h-screen mt-16 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <h4 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">complete your <span className="text-amber-500">booking</span></h4>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 bg-white rounded-[3rem] shadow-2xl overflow-hidden border border-slate-100">
                    {/* Tour Details Side */}
                    <div className="flex flex-col">
                        <div className="relative h-96 lg:h-full min-h-[400px]">
                            <img src={details?.img} className="w-full h-full object-cover" alt={details?.title}/>
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent"></div>
                            <div className="absolute bottom-0 left-0 p-12 w-full">
                                <h2 className="text-4xl font-black text-white mb-6 drop-shadow-2xl">{details?.title}</h2>
                                <div className="flex flex-wrap gap-6 text-white font-bold italic tracking-wider uppercase text-xs">
                                    <span className="flex items-center px-4 py-2 bg-amber-500 text-slate-900 rounded-full shadow-lg shadow-amber-500/20 transform -rotate-3"><i className="fas fa-tag mr-2"></i> ${details?.cost} / Person</span>
                                    <span className="flex items-center px-4 py-2 bg-slate-900 text-white rounded-full border border-slate-700 shadow-xl rotate-2"><i className="fas fa-calendar-day mr-2"></i> {details?.duration} Days</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Booking Form Side */}
                    <div className="p-10 lg:p-20">
                        <div className="flex items-center space-x-4 mb-10 border-b border-slate-100 pb-8">
                            <div className="w-12 h-12 bg-amber-500 rounded-2xl flex items-center justify-center shadow-lg shadow-amber-500/20">
                                <i className="fas fa-user-edit text-slate-900 text-xl"></i>
                            </div>
                            <h3 className="text-2xl font-black text-slate-900 tracking-tight uppercase">Passenger Details</h3>
                        </div>
                        
                        <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
                            {details?.title && (
                                <div>
                                    <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Selected Tour</label>
                                    <input
                                        {...register("title")}
                                        defaultValue={details?.title}
                                        readOnly
                                        className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl text-slate-500 font-bold focus:outline-none"
                                    />
                                </div>
                            )}
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div>
                                    <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Full Name</label>
                                    <input
                                        {...register("name", { required: true })}
                                        defaultValue={user?.displayName}
                                        placeholder="John Doe"
                                        className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Email Address</label>
                                    <input
                                        {...register("email", { required: true })}
                                        defaultValue={user?.email}
                                        type="email"
                                        placeholder="john@example.com"
                                        className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div>
                                    <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Travel Date</label>
                                    <input
                                        {...register("date", { required: true })}
                                        type="date"
                                        className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Gender</label>
                                    <select 
                                        {...register("gender")} 
                                        className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold appearance-none"
                                    >
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">City/Location</label>
                                <input
                                    {...register("city", { required: true })}
                                    placeholder="New York, NY"
                                    className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                                />
                            </div>

                            {Object.keys(errors).length > 0 && (
                                <div className="flex items-center p-4 bg-red-50 text-red-600 rounded-2xl border border-red-100">
                                    <i className="fas fa-exclamation-circle mr-3 text-lg"></i>
                                    <p className="text-sm font-bold uppercase tracking-wide">Please fill in all required fields.</p>
                                </div>
                            )}
                            
                            <div className="pt-6">
                                <button 
                                    type="submit" 
                                    className="w-full bg-slate-900 hover:bg-amber-500 text-white hover:text-slate-900 font-black py-5 rounded-2xl shadow-xl hover:shadow-amber-500/20 transition-all active:scale-[0.98] uppercase tracking-[0.2em] text-sm"
                                >
                                    Confirm Booking
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TourBooking;